import { Client } from '@/common/services/Client';

export async function deleteBillingNote(
  billingUuid: string,
  noteUuid: string,
): Promise<void> {
  await Client.delete({
    endpoint: `/billing/${billingUuid}/notes/${noteUuid}`,
  });
}
